module.exports = __webpack_public_path__ + "img/轮廓映射.90b9d0b3.svg";